module.exports = __webpack_public_path__ + "img/resource-tech-image-17.732b9f94.jpg";